const misc = {
  methods: {
    removeAllRanges() {
      // Remove focus from any focused element
      if (document.activeElement) {
        document.activeElement.blur();
      }

      const sel = window.getSelection
        ? window.getSelection()
        : document.selection;
      if (sel) {
        if (sel.removeAllRanges) {
          sel.removeAllRanges();
        } else if (sel.empty) {
          sel.empty();
        }
      }
    },
  },
};

export default misc;
